export default __webpack_public_path__ + "static/media/img-hf-bonus.08edef10.png";